module.exports = __webpack_public_path__ + "static/media/JnPLogo.5f698303.png";